"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createStore_1 = __importDefault(require("./createStore"));
const createStore_2 = require("./createStore");
const TagCategoryActions_1 = __importDefault(require("../actions/TagCategoryActions"));
const TagCategorySource_1 = __importDefault(require("../sources/TagCategorySource"));
const TagCategory_1 = __importDefault(require("../models/TagCategory"));
const Enums_1 = require("../../models/Enums");
class TagCategoryStore extends createStore_2.BaseStore {
    constructor() {
        super();
        // State
        this.tagCategories = [];
        this.errorMessage = null;
    }
    getActionsHandlers() {
        return {
            receivedItems: TagCategoryActions_1.default.receivedItems,
            loadingItems: TagCategoryActions_1.default.loadingItems,
            fetchingItemsFailed: TagCategoryActions_1.default.fetchingItemsFailed,
        };
    }
    getState() {
        return this;
    }
    getPublicMethods() {
        return {
            getTagCategory: this.getTagCategory,
            getTagCategoryByName: this.getTagCategoryByName,
            getTagImportCategories: this.getTagImportCategories,
            getTagCategories: this.getTagCategories,
            getTagForCatId: this.getTagForCatId,
            getTagForCode: this.getTagForCode,
            findTag: this.findTag,
            getTotalTagForCategory: this.getTotalTagForCategory,
            getOtherTagForCategory: this.getOtherTagForCategory,
            getTagsByLedgerType: this.getTagsByLedgerType,
            getIncomeStatementTagCategories: this.getIncomeStatementTagCategories,
            getBalanceSheetTagCategories: this.getBalanceSheetTagCategories,
        };
    }
    getSource() {
        return TagCategorySource_1.default;
    }
    clearErrors() {
        this.errorMessage = null;
    }
    setErrors(errorMessage) {
        this.errorMessage = errorMessage;
    }
    receivedItems(data) {
        this.tagCategories = data.map(item => new TagCategory_1.default(item));
        this.errorMessage = null;
    }
    loadingItems() {
        // Do nothing
    }
    fetchingItemsFailed(errorMessage) {
        this.setErrors(errorMessage);
    }
    // ---- PUBLIC ----
    getTagCategory(id) {
        const category = this.getState().tagCategories
            .find(tagCategory => tagCategory.id == id);
        if (!category) {
            throw new Error(`No category found with id "${id}"`);
        }
        return category;
    }
    getTagCategoryByName(name) {
        return this.getTagImportCategories()
            .find(tagCategory => tagCategory.name == name) || null;
    }
    //only returns tag categories to display, no import-only categories e.g. Net Profit
    getTagCategories() {
        return this.getTagImportCategories().filter(cat => cat.name !== 'Profit');
    }
    getTagImportCategories() {
        return this.getState().tagCategories;
    }
    //find tag that returns true from func(tag)
    findTag(func) {
        const tag = this.getState().tagCategories
            .reduce((prev, curr) => prev.concat(curr.tags), [])
            .find(tag => func(tag));
        return tag || null;
    }
    getTagForCatId(id) {
        return this.findTag(tag => tag.tag_category_id == id);
    }
    getTagForCode(code) {
        return this.findTag(tag => tag.code == code);
    }
    //returns null if category has no total tag
    //Profit has no total tag
    getTotalTagForCategory(id) {
        const category = this.getTagCategory(id);
        let tag = category.tags.find(tag => tag.isTotal);
        return tag || null;
    }
    getOtherTagForCategory(id) {
        const category = this.getTagCategory(id);
        const tag = category.tags.find(tag => tag.name === 'Other');
        return tag || null;
    }
    getTagsByLedgerType(ledgerType) {
        return this.getTagCategories()
            .filter(item => item.ledger_type == ledgerType);
    }
    getIncomeStatementTagCategories() {
        return this.getTagsByLedgerType(Enums_1.LedgerTypes.IncomeStatement.name);
    }
    getBalanceSheetTagCategories() {
        return this.getTagsByLedgerType(Enums_1.LedgerTypes.BalanceSheet.name);
    }
}
const store = (0, createStore_1.default)(TagCategoryStore, 'TagCategoryStore');
exports.default = store;
